






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { BBadge } from "bootstrap-vue";
import { SportEventRegistrationStatus, SportEventStatus } from "@/models/sport-events.model";
import { statusVariantFilter } from "@/filters/status-variant.filter";

@Component({
  name: "AppStatusBadge",
  filters: {
    statusVariantFilter
  },
  components: { BBadge }
})
export default class AppStatusBadge extends Vue {
  @Prop({ required: true }) status: SportEventStatus;
}
